/* unplugin-vue-components disabled */import { render } from "./MossCopyRender.vue?vue&type=template&id=95555b0a&scoped=true"
import script from "./MossCopyRender.vue?vue&type=script&lang=js"
export * from "./MossCopyRender.vue?vue&type=script&lang=js"

import "./MossCopyRender.vue?vue&type=style&index=0&id=95555b0a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95555b0a"]])

export default __exports__